import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import { TextField, SelectField } from 'redux-form-material-ui';
import { reduxForm, Field } from 'redux-form';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import MenuItem from 'material-ui/MenuItem';
import { translate } from 'react-i18next';

import { required, email } from '../utils/form-validators';
import i18n from '../translations/i18n';
/*
  Styled components
 */
const ButtonContainer = styled.div`
  margin-top: 30;
  float: right;
`;

const StyledSubmitButton = styled(RaisedButton)`
  margin-left: 5 !important;
`;

/*
  PropTypes / DefaultProps
 */
const propTypes = {
  isModify: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const defaultProps = {
  isModify: false,
};

const AccountForm = (props) => {
  const { handleSubmit, isModify } = props;
  const passValidation = isModify ? [required] : null;
  const usernameDisabled = !!isModify;

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={TextField}
        validate={[required]}
        disabled={usernameDisabled}
        name="username"
        hintText={props.t('username')}
        floatingLabelText={props.t('username')}
        fullWidth
      />

      <Field
        component={TextField}
        validate={passValidation}
        name="password"
        type="password"
        hintText={props.t('password')}
        floatingLabelText={props.t('password')}
        fullWidth
      />

      <Field
        component={TextField}
        validate={[required]}
        name="full_name"
        hintText={props.t('name')}
        floatingLabelText={props.t('name')}
        fullWidth
      />

      <Field
        component={TextField}
        validate={[required, email]}
        name="email"
        hintText={props.t('email')}
        floatingLabelText={props.t('email')}
        fullWidth
      />

      <Field
        name="role"
        component={SelectField}
        hintText={props.t('role')}
        fullWidth
        floatingLabelText={props.t('role')}
      >
        <MenuItem value="ADMIN" primaryText={props.t('ADMIN')} />
        <MenuItem value="SUPER_ADMIN" primaryText={props.t('SUPER_ADMIN')} />
      </Field>

      <ButtonContainer>
        <Link onClick={browserHistory.goBack}>
          <RaisedButton label={props.t('back')} />
        </Link>

        <StyledSubmitButton label={props.t('save')} type="submit" primary />
      </ButtonContainer>
    </form>
  );
};

AccountForm.propTypes = propTypes;
AccountForm.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(AccountForm);
export default reduxForm({ form: 'account' })(localize(extended, 'locale'));



// WEBPACK FOOTER //
// ./src/components/AccountForm.js